export default "__VITE_ASSET__DcgrsdoO__"